exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu--inline.user-story-menu,\n.v-menu--inline.team-members-menu {\n  width: 100%;\n  background: white;\n}\n.v-menu__content {\n  background: white;\n}\n", ""]);

// exports
